import $ from 'jquery';
window.$ = window.jQuery = $;
import 'bootstrap';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
// import './bootstrap.js';

const setActiveNavLinks = () => {
    const normalizePath = (value) => {
        if (!value) {
            return '/';
        }
        const trimmed = value.replace(/\/+$/, '');
        return trimmed || '/';
    };

    const currentPath = normalizePath(window.location.pathname);

    document.querySelectorAll('.navbar-collapse.navbar-drawer .nav-link[href]').forEach((link) => {
        const rawHref = link.getAttribute('href') || '';
        if (!rawHref || rawHref.startsWith('#') || rawHref.startsWith('javascript:')) {
            return;
        }
        if (rawHref.startsWith('mailto:') || rawHref.startsWith('tel:')) {
            return;
        }
        let linkPath;
        try {
            const url = new URL(link.href, window.location.origin);
            linkPath = normalizePath(url.pathname);
        } catch (error) {
            return;
        }
        if (linkPath === currentPath) {
            link.classList.add('active');
            link.setAttribute('aria-current', 'page');
        }
    });
};

const initMobileDrawers = () => {
    const drawers = Array.from(document.querySelectorAll('[data-mobile-drawer]'));
    if (!drawers.length) {
        return;
    }

    const openClass = 'mobile-drawer-open';
    const activeDrawerSelector = '.navbar-collapse.navbar-drawer.is-open';

    const isVisible = (element) => {
        if (!element) {
            return false;
        }
        return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    };

    const updateBodyState = () => {
        const hasOpenDrawer = Boolean(document.querySelector(activeDrawerSelector));
        document.body.classList.toggle(openClass, hasOpenDrawer);
    };

    const focusFirstMenuItem = (drawer) => {
        const candidates = Array.from(
            drawer.querySelectorAll('.navbar-nav a, .navbar-nav button, .navbar-nav [tabindex]:not([tabindex="-1"])')
        );
        const target = candidates.find(
            (element) => !element.hasAttribute('disabled') && isVisible(element)
        );
        if (target && typeof target.focus === 'function') {
            target.focus({ preventScroll: true });
        }
    };

    drawers.forEach((drawer) => {
        const drawerId = drawer.getAttribute('id');
        if (!drawerId) {
            return;
        }

        const toggle = document.querySelector(
            `[data-mobile-drawer-toggle][aria-controls="${drawerId}"]`
        );
        const overlay = document.querySelector(
            `[data-mobile-drawer-overlay][data-mobile-drawer-for="${drawerId}"]`
        );
        const closeButton = drawer.querySelector('[data-mobile-drawer-close]');
        const breakpoint = Number.parseFloat(drawer.dataset.mobileDrawerBreakpoint || '0');

        const isWithinBreakpoint = () => !breakpoint || window.innerWidth <= breakpoint;
        const syncDrawerViewportHeight = () => {
            if (!isWithinBreakpoint()) {
                drawer.style.removeProperty('--mobile-drawer-height');
                return;
            }

            const viewportHeight = Math.round(window.visualViewport?.height || window.innerHeight);
            if (viewportHeight > 0) {
                drawer.style.setProperty('--mobile-drawer-height', `${viewportHeight}px`);
            }
        };

        const setExpanded = (expanded) => {
            if (toggle) {
                toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            }
        };

        const openDrawer = () => {
            if (!isWithinBreakpoint()) {
                return;
            }
            syncDrawerViewportHeight();
            drawer.classList.add('is-open');
            setExpanded(true);
            updateBodyState();
            window.setTimeout(() => {
                if (drawer.classList.contains('is-open')) {
                    focusFirstMenuItem(drawer);
                }
            }, 80);
        };

        const closeDrawer = () => {
            drawer.classList.remove('is-open');
            setExpanded(false);
            updateBodyState();
        };

        const toggleDrawer = () => {
            if (drawer.classList.contains('is-open')) {
                closeDrawer();
            } else {
                openDrawer();
            }
        };

        if (toggle) {
            toggle.addEventListener('click', (event) => {
                event.preventDefault();
                toggleDrawer();
            });
        }

        if (overlay) {
            overlay.addEventListener('click', closeDrawer);
        }

        if (closeButton) {
            closeButton.addEventListener('click', closeDrawer);
        }

        document.addEventListener('keydown', (event) => {
            if (!drawer.classList.contains('is-open')) {
                return;
            }
            if (event.key === 'Escape') {
                event.preventDefault();
                closeDrawer();
                toggle?.focus({ preventScroll: true });
            } else if (event.key === 'Tab') {
                const items = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]'))
                    .filter((element) => isVisible(element) && getComputedStyle(element).visibility !== 'hidden');
                const first = items[0];
                const last = items[items.length - 1];
                if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
                    event.preventDefault();
                    last?.focus();
                } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
                    event.preventDefault();
                    first?.focus();
                }
            }
        });

        drawer.addEventListener('click', (event) => {
            const link = event.target.closest('.navbar-nav a, .navbar-nav button');
            if (!link) {
                return;
            }
            if (link.getAttribute('data-bs-toggle') === 'dropdown') {
                return;
            }
            closeDrawer();
        });

        window.addEventListener('resize', () => {
            syncDrawerViewportHeight();
            if (!breakpoint) {
                return;
            }
            if (window.innerWidth > breakpoint && drawer.classList.contains('is-open')) {
                closeDrawer();
            }
        });

        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', syncDrawerViewportHeight);
            window.visualViewport.addEventListener('scroll', syncDrawerViewportHeight);
        }

        syncDrawerViewportHeight();
    });
};

document.addEventListener('DOMContentLoaded', () => {
    initMobileDrawers();
    setActiveNavLinks();
    initChatbotWidget();

    const profileTabs = document.getElementById('profile-tabs');
    if (profileTabs) {
        const revealTab = (tab) => {
            if (window.matchMedia('(max-width: 767.98px)').matches) {
                tab?.scrollIntoView({ block: 'nearest', inline: 'center' });
            }
        };
        window.requestAnimationFrame(() => revealTab(profileTabs.querySelector('.nav-link.active')));
        document.fonts.ready.then(() => revealTab(profileTabs.querySelector('.nav-link.active')));
        profileTabs.addEventListener('shown.bs.tab', (event) => revealTab(event.target));
    }
});

const initChatbotWidget = () => {
    const widget = document.querySelector('[data-chatbot-widget]');
    if (!widget) {
        return;
    }

    const panel = widget.querySelector('.chatbot-widget__panel');
    const toggle = widget.querySelector('[data-chatbot-toggle]');
    const closeButton = widget.querySelector('[data-chatbot-close]');
    const messagesContainer = widget.querySelector('[data-chatbot-messages]');
    const transcriptScroll = widget.querySelector('[data-chatbot-scroll]') || messagesContainer;
    const status = widget.querySelector('[data-chatbot-status]');
    const form = widget.querySelector('[data-chatbot-form]');
    const operatorPanel = widget.querySelector('[data-chatbot-operator]');
    const operatorForm = widget.querySelector('[data-chatbot-operator-form]');
    const openOperatorButtons = widget.querySelectorAll('[data-chatbot-open-operator]');
    const closeOperatorButton = widget.querySelector('[data-chatbot-close-operator]');
    const operatorError = widget.querySelector('[data-chatbot-operator-error]');
    const menuToggle = widget.querySelector('[data-chatbot-menu-toggle]');
    const menu = widget.querySelector('[data-chatbot-menu]');
    const quickActionsContainer = widget.querySelector('[data-chatbot-quick-actions]');
    const storageKey = widget.dataset.threadStorageKey || 'go_transfer_chatbot_thread_uuid';
    const messagesEndpoint = widget.dataset.messagesEndpoint || '';
    const threadTemplate = widget.dataset.threadEndpointTemplate || '';
    const operatorTemplate = widget.dataset.operatorEndpointTemplate || '';
    const routeName = widget.dataset.routeName || '';
    const path = widget.dataset.path || window.location.pathname || '/';
    const tripId = widget.dataset.tripId ? Number(widget.dataset.tripId) : null;
    const cookieBanner = document.getElementById('cookie-banner');
    const cookieConsentStorageKey = 'gtm_consent_preferences';
    const mobileCookieBannerQuery = window.matchMedia('(max-width: 767.98px)');
    const quickActions = (() => {
        try {
            return JSON.parse(widget.dataset.quickActions || '[]');
        } catch (error) {
            return [];
        }
    })();
    const i18n = (() => {
        try {
            return JSON.parse(widget.dataset.i18n || '{}');
        } catch (error) {
            return {};
        }
    })();

    let threadUuid = window.localStorage.getItem(storageKey) || '';
    let booted = false;
    let pendingMessageNode = null;
    let requestPending = false;
    let operatorTrigger = null;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
    const pageContext = () => ({
        route_name: routeName,
        path,
        title: document.title || '',
        ...(Number.isFinite(tripId) && tripId > 0 ? { trip_id: tripId } : {}),
    });
    const fieldSelectors = {
        service_type: ['[name="service_type"]'],
        pickup_location: ['[name="pickup_location"]', '[data-transfer-detail-place="pickup"]', '[data-transfer-search-place="pickup"]'],
        pickup_region: ['[name="pickup_region"]', '[data-transfer-detail-region="pickup"]'],
        pickup_location_precision: ['[name="pickup_location_precision"]', '[data-transfer-detail-location-precision="pickup"]'],
        pickup_latitude: ['[name="pickup_latitude"]', '[data-transfer-detail-lat="pickup"]'],
        pickup_longitude: ['[name="pickup_longitude"]', '[data-transfer-detail-lng="pickup"]'],
        drop_location: ['[name="drop_location"]', '[data-transfer-detail-place="drop"]', '[data-transfer-search-place="drop"]'],
        drop_region: ['[name="drop_region"]', '[data-transfer-detail-region="drop"]'],
        drop_location_precision: ['[name="drop_location_precision"]', '[data-transfer-detail-location-precision="drop"]'],
        drop_latitude: ['[name="drop_latitude"]', '[data-transfer-detail-lat="drop"]'],
        drop_longitude: ['[name="drop_longitude"]', '[data-transfer-detail-lng="drop"]'],
        distance: ['[name="distance"]'],
        duration_seconds: ['[name="duration_seconds"]'],
        pickup_datetime: ['[name="pickup_datetime"]', '[data-transfer-detail-datetime="pickup"]', '[data-transfer-search-datetime="pickup"]'],
        return_datetime: ['[name="return_datetime"]', '[data-transfer-detail-datetime="return"]', '[data-transfer-search-datetime="return"]'],
        passengers: ['[name="passengers"]'],
        luggage: ['[name="luggage"]'],
        car_type: ['[name="car_type"]'],
        round_trip: ['[name="round_trip"]', '[data-transfer-detail-round-trip]'],
    };

    const resolveFieldState = (selectors) => {
        let fieldExists = false;

        for (const selector of selectors) {
            const nodes = Array.from(document.querySelectorAll(selector));
            for (const node of nodes) {
                if (!node) {
                    continue;
                }

                if ('value' in node) {
                    fieldExists = true;
                    const value = String(node.value || '').trim();
                    if (value === '') {
                        continue;
                    }

                    return {
                        exists: true,
                        value,
                    };
                }
            }
        }

        return {
            exists: fieldExists,
            value: '',
        };
    };

    const collectBookingDraft = () => {
        const draft = {};

        Object.entries(fieldSelectors).forEach(([key, selectors]) => {
            const state = resolveFieldState(selectors);
            if (!state.exists) {
                return;
            }

            draft[key] = state.value;
        });

        return draft;
    };

    const setNodeValue = (node, value) => {
        if (!node || !('value' in node)) {
            return;
        }

        const normalizedValue = typeof value === 'string' ? value : String(value ?? '');

        if (node._flatpickr) {
            if (normalizedValue.trim()) {
                node._flatpickr.setDate(normalizedValue, true);
            } else {
                node._flatpickr.clear();
                node.value = '';
            }
        } else if (node.type === 'checkbox') {
            node.checked = ['1', 'true', 'yes', 'on'].includes(normalizedValue.toLowerCase());
        } else {
            node.value = normalizedValue;
        }

        node.dispatchEvent(new Event('input', { bubbles: true }));
        node.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const persistDraftSnapshot = (bookingDraft) => {
        try {
            ['pickup_location', 'drop_location', 'pickup_datetime', 'return_datetime'].forEach((key) => {
                if (typeof bookingDraft[key] === 'string') {
                    window.localStorage.setItem(key, bookingDraft[key]);
                }
            });
        } catch (error) {
        }
    };

    const applyBookingDraftToPage = (bookingDraft) => {
        if (!bookingDraft || typeof bookingDraft !== 'object' || Array.isArray(bookingDraft)) {
            return;
        }

        const customDraftApplier = typeof window.applyTransferBookingDraft === 'function'
            ? window.applyTransferBookingDraft
            : null;
        if (customDraftApplier) {
            try {
                const handled = customDraftApplier(bookingDraft);
                persistDraftSnapshot(bookingDraft);
                if (handled) {
                    return;
                }
            } catch (error) {
            }
        }

        Object.entries(fieldSelectors).forEach(([key, selectors]) => {
            if (!(key in bookingDraft)) {
                return;
            }

            const value = bookingDraft[key];
            if (value === null || typeof value === 'undefined') {
                return;
            }

            selectors.forEach((selector) => {
                document.querySelectorAll(selector).forEach((node) => {
                    setNodeValue(node, value);
                });
            });
        });

        persistDraftSnapshot(bookingDraft);
    };

    const setStatus = (operatorStatus) => {
        const labels = i18n.status_labels || {
            none: 'I can help with bookings, rides, and support.',
            requested: 'Operator request sent.',
            claimed: 'Operator request taken in charge.',
            closed: 'Operator request closed.',
        };
        status.textContent = operatorStatus === 'none'
            ? (i18n.ready_label || labels.none)
            : (labels[operatorStatus] || i18n.ready_label || labels.none);
    };

    const escapeHtml = (value) => {
        const div = document.createElement('div');
        div.textContent = value || '';
        return div.innerHTML;
    };

    const formatAssistantMessageText = (value) => escapeHtml(value)
        .replace(/&lt;strong&gt;([\s\S]*?)&lt;\/strong&gt;/gi, '<strong>$1</strong>')
        .replace(/\*\*([^*\r\n]+)\*\*/g, '<strong>$1</strong>');

    const iconMarkup = (name) => `<svg class="chatbot-widget__icon" aria-hidden="true"><use href="#chatbot-icon-${name}"/></svg>`;
    const avatarMarkup = () => `<span class="chatbot-widget__avatar" aria-hidden="true">${iconMarkup('robot')}</span>`;
    const scrollTranscript = () => {
        transcriptScroll.scrollTop = transcriptScroll.scrollHeight;
    };
    const syncConversationState = () => {
        widget.classList.toggle('has-conversation', Boolean(messagesContainer.querySelector('[data-chatbot-message]')));
    };
    const setMenuOpen = (open) => {
        if (!menu) return;
        menu.hidden = !open;
        menuToggle?.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    const setOperatorPanel = (open, trigger = null) => {
        if (!operatorPanel) return;
        operatorPanel.hidden = !open;
        widget.classList.toggle('is-operator-open', open);
        setMenuOpen(false);
        if (operatorError) operatorError.hidden = true;
        if (open) {
            operatorTrigger = trigger || document.activeElement;
            operatorPanel.querySelector('input, textarea')?.focus({ preventScroll: true });
        } else {
            const focusTarget = operatorTrigger?.getClientRects().length
                ? operatorTrigger
                : form?.querySelector('[name="message"]');
            focusTarget?.focus({ preventScroll: true });
        }
    };
    const setRequestPending = (pending) => {
        requestPending = pending;
        messagesContainer.setAttribute('aria-busy', pending ? 'true' : 'false');
        widget.querySelectorAll('button[type="submit"], .chatbot-widget__quick-action, [data-chatbot-open-operator]').forEach((button) => {
            button.disabled = pending;
        });
    };
    const messageFrame = (content, role, createdAt = null) => {
        const date = createdAt ? new Date(createdAt) : new Date();
        const timestamp = Number.isNaN(date.getTime()) ? '' : `<time class="chatbot-message__time" datetime="${date.toISOString()}">${escapeHtml(new Intl.DateTimeFormat(widget.dataset.locale || document.documentElement.lang || 'en', { hour: '2-digit', minute: '2-digit' }).format(date))}</time>`;
        const sender = role === 'user' ? '' : `<div class="chatbot-message__sender">${escapeHtml(i18n.brand || 'GoTransfer')}</div>`;
        return `${role === 'user' ? '' : avatarMarkup()}<div class="chatbot-message__bubble">${sender}${content}${timestamp}</div>`;
    };

    const appendQuickActions = () => {
        if (!quickActionsContainer || quickActionsContainer.dataset.ready === 'true') {
            return;
        }

        quickActions.forEach((action) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'chatbot-widget__quick-action';
            const icons = {
                become_driver: 'user', driver_onboarding: 'user',
                driver_chat: 'chat', my_chats: 'chat',
                add_date_time: 'clock', cancellation_policy: 'shield', cancel_ride: 'shield',
                operator_request: 'headset',
            };
            button.innerHTML = `${iconMarkup(icons[action.type] || 'car')}
                <span class="chatbot-widget__quick-action-copy">
                    <span class="chatbot-widget__quick-action-label">${escapeHtml(action.label || action.prompt || '...')}</span>
                    ${action.description ? `<span class="chatbot-widget__quick-action-description">${escapeHtml(action.description)}</span>` : ''}
                </span>${iconMarkup('arrow')}`;
            button.addEventListener('click', () => {
                if (typeof action.url === 'string' && action.url.trim() !== '') {
                    window.location.assign(action.url);
                    return;
                }

                if (action.type === 'operator_request') {
                    setOperatorPanel(true, button);
                    return;
                }

                const input = form?.querySelector('[name="message"]');
                if (!input) {
                    return;
                }
                input.value = action.prompt || '';
                form.requestSubmit();
            });
            quickActionsContainer.appendChild(button);
        });

        quickActionsContainer.dataset.ready = 'true';
    };

    const isOpen = () => widget.classList.contains('is-open');

    const closeWidget = ({ restoreFocus = true } = {}) => {
        widget.classList.remove('is-open');
        setMenuOpen(false);
        toggle?.setAttribute('aria-expanded', 'false');
        panel?.setAttribute('aria-hidden', 'true');
        if (restoreFocus) {
            window.requestAnimationFrame(() => {
                toggle?.focus({ preventScroll: true });
            });
        }
    };

    const openWidget = async () => {
        widget.classList.add('is-open');
        toggle?.setAttribute('aria-expanded', 'true');
        panel?.setAttribute('aria-hidden', 'false');
        panel?.focus({ preventScroll: true });

        if (!booted) {
            booted = true;
            appendQuickActions();
            await loadThread();
        }
    };

    const readCookieConsentPreferences = () => {
        try {
            const stored = window.localStorage.getItem(cookieConsentStorageKey);
            return stored ? JSON.parse(stored) : null;
        } catch (error) {
            return null;
        }
    };

    const isCookieBannerVisible = () => {
        if (!cookieBanner) {
            return false;
        }

        return cookieBanner.classList.contains('is-visible');
    };

    const syncChatbotCookieVisibility = () => {
        const hasStoredConsent = readCookieConsentPreferences() !== null;
        const shouldBlockOnMobile = mobileCookieBannerQuery.matches
            && (isCookieBannerVisible() || (cookieBanner && !hasStoredConsent));

        widget.dataset.chatbotCookieBlocked = shouldBlockOnMobile ? 'true' : 'false';
        widget.dataset.chatbotReady = 'true';

        if (shouldBlockOnMobile && isOpen()) {
            closeWidget({ restoreFocus: false });
        }
    };

    toggle?.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
    panel?.setAttribute('aria-hidden', isOpen() ? 'false' : 'true');

    if (cookieBanner) {
        const observer = new MutationObserver(syncChatbotCookieVisibility);
        observer.observe(cookieBanner, {
            attributes: true,
            attributeFilter: ['class', 'hidden', 'style'],
        });
    }

    if (typeof mobileCookieBannerQuery.addEventListener === 'function') {
        mobileCookieBannerQuery.addEventListener('change', syncChatbotCookieVisibility);
    } else if (typeof mobileCookieBannerQuery.addListener === 'function') {
        mobileCookieBannerQuery.addListener(syncChatbotCookieVisibility);
    }

    window.addEventListener('storage', (event) => {
        if (!event.key || event.key === cookieConsentStorageKey) {
            syncChatbotCookieVisibility();
        }
    });

    syncChatbotCookieVisibility();

    // Leave the entire booking area unobstructed on phones and tablets.
    const mobileBookingQuery = window.matchMedia('(max-width: 1199.98px)');
    const bookingAreas = Array.from(document.querySelectorAll(
        '[data-transfer-search-form], #detailForm, #transferForm, .transfer-sticky-cta, .transfer-payment-card, .transfer-payment-sticky'
    ));
    const syncChatbotBookingVisibility = () => {
        const viewport = window.visualViewport;
        const viewportTop = viewport?.offsetTop || 0;
        const viewportLeft = viewport?.offsetLeft || 0;
        const viewportBottom = viewportTop + (viewport?.height || window.innerHeight);
        const viewportRight = viewportLeft + (viewport?.width || window.innerWidth);
        const clearance = 16;
        const shouldBlock = mobileBookingQuery.matches && bookingAreas.some((area) => {
            const rect = area.getBoundingClientRect();
            return rect.width > 0 && rect.height > 0
                && rect.bottom > viewportTop - clearance
                && rect.top < viewportBottom + clearance
                && rect.right > viewportLeft - clearance
                && rect.left < viewportRight + clearance;
        });

        widget.dataset.chatbotBookingBlocked = shouldBlock ? 'true' : 'false';
        if (shouldBlock && isOpen()) {
            closeWidget({ restoreFocus: false });
        }
    };

    window.addEventListener('scroll', syncChatbotBookingVisibility, { passive: true, capture: true });
    if (typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver(syncChatbotBookingVisibility, { rootMargin: '16px' });
        bookingAreas.forEach((area) => observer.observe(area));
    }
    if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(syncChatbotBookingVisibility);
        bookingAreas.forEach((area) => observer.observe(area));
    }

    // Keep the composer above mobile keyboards and inside the visible viewport.
    const syncChatbotViewport = () => {
        const viewport = window.visualViewport;
        widget.style.setProperty('--chatbot-viewport-height', `${viewport?.height || window.innerHeight}px`);
        widget.style.setProperty('--chatbot-keyboard-offset', `${Math.max(0, window.innerHeight - (viewport?.height || window.innerHeight) - (viewport?.offsetTop || 0))}px`);
        syncChatbotBookingVisibility();
    };
    window.visualViewport?.addEventListener('resize', syncChatbotViewport);
    window.visualViewport?.addEventListener('scroll', syncChatbotViewport);
    window.addEventListener('resize', syncChatbotViewport);
    syncChatbotViewport();

    const renderMessage = (message) => {
        const node = document.createElement('div');
        const role = ['assistant', 'user', 'system'].includes(message.role) ? message.role : 'assistant';
        node.className = `chatbot-message chatbot-message--${role}`;
        node.setAttribute('data-chatbot-message', 'true');

        const messageText = message.role === 'assistant'
            ? formatAssistantMessageText(message.text || '')
            : escapeHtml(message.text || '');
        let html = `<div class="chatbot-message__text">${messageText}</div>`;

        if (Array.isArray(message.links) && message.links.length > 0) {
            html += '<div class="chatbot-message__links">';
            message.links.forEach((link) => {
                html += `<a class="chatbot-message__link" href="${escapeHtml(link.url)}">${escapeHtml(link.label)}</a>`;
            });
            html += '</div>';
        }

        if (message.booking_cta && message.booking_cta.url) {
            html += `<a class="chatbot-message__cta" href="${escapeHtml(message.booking_cta.url)}">${escapeHtml(message.booking_cta.label || i18n.open_booking_label || 'Open booking')}</a>`;
        }

        if (Array.isArray(message.missing_fields) && message.missing_fields.length > 0) {
            html += `<div class="chatbot-message__meta">${escapeHtml(i18n.missing_fields_label || 'Fields still needed')}: ${escapeHtml(message.missing_fields.join(', '))}</div>`;
        }

        node.innerHTML = messageFrame(html, role, message.created_at);
        messagesContainer.appendChild(node);
        syncConversationState();
        scrollTranscript();
    };

    const renderTypingIndicator = (role = 'assistant') => {
        removeTypingIndicator();

        const node = document.createElement('div');
        node.className = `chatbot-message chatbot-message--${role} chatbot-message--typing`;
        node.setAttribute('data-chatbot-typing', 'true');
        node.innerHTML = `${avatarMarkup()}<div class="chatbot-message__bubble">
            <div class="chatbot-message__typing" role="status" aria-label="${escapeHtml(i18n.loading_label || 'Loading')}">
                <span class="chatbot-message__typing-dot"></span>
                <span class="chatbot-message__typing-dot"></span>
                <span class="chatbot-message__typing-dot"></span>
            </div></div>
        `;

        messagesContainer.appendChild(node);
        scrollTranscript();
        pendingMessageNode = node;
    };

    const removeTypingIndicator = () => {
        if (!pendingMessageNode) {
            return;
        }

        pendingMessageNode.remove();
        pendingMessageNode = null;
    };

    const resetTranscript = () => {
        const items = Array.from(messagesContainer.querySelectorAll('[data-chatbot-message], [data-chatbot-typing]'));
        items.forEach((item) => item.remove());
        pendingMessageNode = null;
        syncConversationState();
    };

    const genericServerErrorMessages = new Set([
        'Unauthenticated.',
        'Unauthorized',
        'Forbidden',
        'This action is unauthorized.',
        'CSRF token mismatch.',
        'Page Expired',
        'Too Many Attempts.',
        'Too Many Requests',
        'Server Error',
        'Service Unavailable',
    ]);

    const fetchJson = async (url, payload = null) => {
        const response = await fetch(url, {
            method: payload ? 'POST' : 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken,
                'X-Chatbot-Locale': widget.dataset.locale || document.documentElement.lang || 'en',
            },
            body: payload ? JSON.stringify(payload) : null,
            credentials: 'same-origin',
        });

        let responsePayload = null;

        try {
            responsePayload = await response.json();
        } catch (error) {
            responsePayload = null;
        }

        if (!response.ok) {
            const validationErrors = responsePayload?.errors && typeof responsePayload.errors === 'object'
                ? Object.values(responsePayload.errors).flat().filter(Boolean)
                : [];
            const serverMessage = typeof responsePayload?.message === 'string'
                ? responsePayload.message.trim()
                : '';
            const localizedFallback = i18n.errors?.message_failed
                || 'Non è stato possibile completare la richiesta. Riprova tra poco.';
            const message = validationErrors[0]
                || (serverMessage && !genericServerErrorMessages.has(serverMessage)
                    ? serverMessage
                    : localizedFallback);
            const requestError = new Error(String(message));
            requestError.status = response.status;
            requestError.payload = responsePayload;
            throw requestError;
        }

        return responsePayload;
    };

    const applyThreadPayload = (payload, { replace = false, hydratePageDraft = true } = {}) => {
        if (payload.thread_uuid) {
            threadUuid = payload.thread_uuid;
            window.localStorage.setItem(storageKey, threadUuid);
        }

        if (replace) {
            resetTranscript();
            (payload.messages || []).forEach((message) => {
                if (message.role === 'assistant' || message.role === 'user' || message.role === 'system') {
                    renderMessage(message);
                }
            });
            const latestAssistantMessage = [...(payload.messages || [])]
                .reverse()
                .find((message) => message.role === 'assistant' && message.booking_draft);
            if (hydratePageDraft && latestAssistantMessage?.booking_draft) {
                applyBookingDraftToPage(latestAssistantMessage.booking_draft);
            }
        } else if (payload.message) {
            renderMessage(payload.message);
            if (hydratePageDraft && payload.message.role === 'assistant' && payload.message.booking_draft) {
                applyBookingDraftToPage(payload.message.booking_draft);
            }
        }

        setStatus(payload.context_flags?.operator_request_status || 'none');
    };

    const loadThread = async () => {
        if (!threadUuid || !threadTemplate) {
            appendQuickActions();
            return;
        }

        try {
            const url = threadTemplate.replace('__THREAD__', threadUuid);
            const payload = await fetchJson(url);
            applyThreadPayload(payload, { replace: true, hydratePageDraft: false });
        } catch (error) {
            window.localStorage.removeItem(storageKey);
            threadUuid = '';
            appendQuickActions();
        }
    };

    const submitMessage = async (text) => {
        renderMessage({ role: 'user', text });
        renderTypingIndicator('assistant');
        const bookingDraft = collectBookingDraft();

        try {
            const payload = await fetchJson(messagesEndpoint, {
                thread_uuid: threadUuid || null,
                message: text,
                page_context: pageContext(),
                booking_draft: bookingDraft,
            });
            removeTypingIndicator();
            applyThreadPayload(payload);
        } catch (error) {
            removeTypingIndicator();
            throw error;
        }
    };

    const submitOperatorRequest = async (formPayload) => {
        renderTypingIndicator('system');

        if (!threadUuid) {
            try {
                const bootstrapPayload = await fetchJson(messagesEndpoint, {
                    thread_uuid: null,
                    message: i18n.operator_request_prompt || 'I would like to talk to an operator.',
                    page_context: pageContext(),
                });
                removeTypingIndicator();
                applyThreadPayload(bootstrapPayload);
                renderTypingIndicator('system');
            } catch (error) {
                removeTypingIndicator();
                throw error;
            }
        }

        try {
            const payload = await fetchJson(operatorTemplate.replace('__THREAD__', threadUuid), formPayload);
            removeTypingIndicator();
            applyThreadPayload(payload);
        } catch (error) {
            removeTypingIndicator();
            throw error;
        }
    };

    toggle?.addEventListener('click', async () => {
        if (widget.dataset.chatbotCookieBlocked === 'true' || widget.dataset.chatbotBookingBlocked === 'true') {
            return;
        }

        if (isOpen()) {
            closeWidget();
            return;
        }

        await openWidget();
    });

    closeButton?.addEventListener('click', () => {
        closeWidget();
    });

    openOperatorButtons.forEach((button) => {
        button.addEventListener('click', () => setOperatorPanel(true, button));
    });

    closeOperatorButton?.addEventListener('click', () => {
        setOperatorPanel(false);
    });

    menuToggle?.addEventListener('click', () => setMenuOpen(menu.hidden));
    document.addEventListener('click', (event) => {
        if (!menu?.hidden && !menu.contains(event.target) && !menuToggle?.contains(event.target)) {
            setMenuOpen(false);
        }
    });
    widget.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !isOpen()) return;
        event.preventDefault();
        if (menu && !menu.hidden) {
            setMenuOpen(false);
            menuToggle?.focus({ preventScroll: true });
        } else if (operatorPanel && !operatorPanel.hidden) {
            setOperatorPanel(false);
        } else {
            closeWidget();
        }
    });

    form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (requestPending) return;
        const input = form.querySelector('[name="message"]');
        const text = (input?.value || '').trim();
        if (!text) {
            return;
        }

        input.value = '';
        setRequestPending(true);
        try {
            await submitMessage(text);
        } catch (error) {
            renderMessage({
                role: 'system',
                text: error?.message || i18n.errors?.message_failed || 'Non è stato possibile inviare la richiesta. Riprova tra poco.',
            });
        } finally {
            setRequestPending(false);
        }
    });

    operatorForm?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (requestPending) return;
        const formData = new FormData(operatorForm);
        const payload = {
            reason: String(formData.get('reason') || '').trim(),
        };

        const guestName = String(formData.get('guest_name') || '').trim();
        const guestEmail = String(formData.get('guest_email') || '').trim();

        if (guestName) {
            payload.guest_name = guestName;
        }

        if (guestEmail) {
            payload.guest_email = guestEmail;
        }

        if (!payload.reason) {
            if (operatorError) {
                operatorError.textContent = i18n.errors?.operator_reason_required || 'Inserisci almeno un breve motivo della richiesta.';
                operatorError.hidden = false;
            }
            return;
        }

        setRequestPending(true);
        if (operatorError) operatorError.hidden = true;
        try {
            await submitOperatorRequest(payload);
            setOperatorPanel(false);
            operatorForm.reset();
            scrollTranscript();
        } catch (error) {
            if (operatorError) {
                operatorError.textContent = error?.message || i18n.errors?.operator_request_failed || 'Non è stato possibile aprire la richiesta operatore. Riprova tra poco.';
                operatorError.hidden = false;
            }
        } finally {
            setRequestPending(false);
        }
    });
};
